import CustomButton from '../../../common/components/CustomButton';
import PopupContainer from '../../../common/components/PopupContainer';
import CurrencyUtility from '../../../common/utility/CurrencyUtility';

export default function KaraokeModificationFormConfirmNeedsRemakePopup({
  onClose,
  onBack,
  onNext,
  remakeFeeAmount,
} : {
  onClose: () => void,
  onBack: () => void,
  onNext: () => void,
  remakeFeeAmount: number,
}) {
  return (
    <PopupContainer title="カラオケ配信サービス" onClose={() => onClose()}>
      {`この曲は制作データの保存期間が終了しているため、再制作扱いとなり、修正手数料が${CurrencyUtility.format(remakeFeeAmount)}円（税込）となります。`}
      <br />
      修正をご希望の場合は次のページに進み、制作に必要な歌詞、音源、映像などのデータをすべてギガファイル便にアップロードし、そのURLを入力してください。
      <br />
      {/* eslint-disable-next-line react/jsx-no-target-blank */}
      <a href="https://help.frekul.com/270/" target="_blank">提出データの詳細はこちら</a>
      <br />
      <br />
      また、本人歌唱、郵送、デュエットのオプションがある場合はその料金も加算されます。その場合は次へ進まず、
      {/* eslint-disable-next-line react/jsx-no-target-blank */}
      <a href="https://frekul.com/contact" target="_blank">こちら</a>
      からご連絡ください。
      <br />
      <br />
      <form>
        <div className="form__data">
          <ul>
            <li className="bt">
              <CustomButton type="cancel-split" onClick={() => onBack()}>ホームに戻る</CustomButton>
              <CustomButton type="default-split" onClick={() => onNext()}>次へ</CustomButton>
            </li>
          </ul>
        </div>
      </form>
    </PopupContainer>
  );
}
